import * as React from "react";
import { Link } from "react-router-dom";
import { IProps } from "./types";

export const ImageButton: React.FC<IProps> = ({
  href,
  imgSrc,
  width,
  height,
  style,
  onClick,
  ...props
}: IProps) => {
  const rgExp = new RegExp("^(?:[a-z]+:)?//", "i");
  const isAbsolute = rgExp.test(href);

  return !!href ? (
    isAbsolute ? (
      <a href={href} style={style} className={props.className}>
        <img src={imgSrc} width={width} height={height} />
      </a>
    ) : (
      <Link to={href} style={style} className={props.className}>
        <img src={imgSrc} width={width} height={height} />
      </Link>
    )
  ) : (
    <img
      className={props.className}
      src={imgSrc}
      width={width}
      height={height}
      style={{ cursor: "pointer" }}
      onClick={onClick}
    />
  );
};
